import { Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { ITimer } from '../../types';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-count-down-timer',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './count-down-timer.component.html',
  //styleUrls: ['./count-down-timer.component.scss']
})
export class CountDownTimerComponent implements OnInit {
  @Input() timeInSeconds: number;
  @Output() timerFinished= new EventEmitter<boolean>();

  private timer: ITimer;
  private countDown;
  
  constructor() { }

  ngOnInit() {
    this.initTimer();
  }

  hasFinished() {
    return this.timer.hasFinished;
  }

  initTimer() {
    if (!this.timeInSeconds) {
      this.timeInSeconds = 0;
    }

    this.timer = <ITimer>{
      seconds: this.timeInSeconds,
      runTimer: false,
      hasStarted: false,
      hasFinished: false,
      secondsRemaining: this.timeInSeconds
    };

    this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);
  }

  startTimer() {
    this.timer.hasStarted = true;
    this.timer.runTimer = true;
    this.timerTick();
  }

  pauseTimer() {
    this.timer.runTimer = false;
  }

  resumeTimer() {
    //this.startTimer();
    this.timer.runTimer = true;
  }

  timerTick() {
    this.countDown = Observable.timer(0, 1000)
    .take(this.timeInSeconds)
    .map(() => {
      if (this.timer.runTimer) {
        this.timer.secondsRemaining --;
      }
      this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);
      if (this.timer.secondsRemaining > 0) {
        this.timerFinished.emit(false);
      } else {
        this.timer.hasFinished = true;
        this.timerFinished.emit(true);
      }
      return this.timer.secondsRemaining;
    });
  }

  getSecondsAsDigitalClock(inputSeconds: number) {
    let sec_num = parseInt(inputSeconds.toString(), 10);
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);
    let hoursString = '';
    let minutesString = '';
    let secondsString = '';
  
    hoursString = (hours < 10) ? '0' + hours : hours.toString();
    minutesString = (minutes < 10) ? '0' + minutes : minutes.toString();
    secondsString = (seconds < 10) ? '0' + seconds : seconds.toString();
    return (hours === 0) ? (minutesString + ':' + secondsString) : (hoursString + ':' + minutesString + ':' + secondsString);
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/count-down-timer/count-down-timer.component.ts